<template>
  <!-----Tabla---->
  <v-simple-table>
    <template v-slot:default>
      <!----Cabecera de la tabla---->
      <thead>
        <tr>
          <th class="text-center">Tipo Identificacion</th>
          <th class="text-center">Numero Identificacion</th>
          <th class="text-center">Tipo Persona</th>
          <th class="text-center">Razon Social</th>
          <th class="text-center">Direccion</th>
          <th class="text-center">Ciudad</th>
          <th class="text-center">Telefono</th>
          <th class="text-center">Email</th>
          <th class="text-center">Contacto</th>
        </tr>
      </thead>
      <!-----Cuerpo de la tabla----->
      <tbody>
        <tr v-for="item in proveedores" :key="item._id">
          <td>{{ item.tipo_identificacion }}</td>
          <td>{{ item.numero_identificacion }}</td>
          <td>{{ item.tipo_persona }}</td>
          <td>{{ item.razon_social }}</td>
          <td>{{ item.direccion }}</td>
          <td>{{ item.ciudad }}</td>
          <td>{{ item.telefono }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.contacto }}</td>
          <!----Columna de acciones--->
          <td>
            <v-btn class="ma-2" outlined color="indigo"> Actualizar </v-btn>
            <v-btn
              class="ma-2"
              outlined
              color="error"
              v-on:click="eliminar(item._id)"
              ><!---@click-->
              Eliminar
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import store from "../store/index.js";

export default {
  methods: {
    
    eliminar(id) {
      console.log("Eliminar-> ", id);
      let obj = { id };
      store.dispatch("eliminarProveedor", obj).then(() => {
        //realiza solicitud get al backend
        store.dispatch("cargarProveedores");
      });
    },
  },
  created: () => {
    //realiza solicitud get al backend
    store.dispatch("cargarProveedores");
  },
  //Propiedades computadas
  computed: {
    proveedores: () => {
      return store.state.proveedores;
    },
  },
};
</script>

<style>
</style>

                
                
                
                
                
                
                
                
                
